
export const routes = (prefix = `suppliers-dashboard`) => [
    {
        path: `/${prefix}/suppliers`,
        name: `${prefix}.suppliers.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.suppliers.index`,
                PageDescription: "Supplier Configurations: Supplier Configuration",
            },
        },
    },
    {
        path: `/${prefix}/suppliers/create`,
        name: `${prefix}.suppliers.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.suppliers.index`,
                PageDescription: "Supplier Configurations: Supplier Configuration",
            },
        },
    },
    {
        path: `/${prefix}/suppliers/edit/:supplierID`,
        name: `${prefix}.suppliers.edit`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.suppliers.index`,
                PageDescription: "Supplier Configurations: Supplier Configuration",
            },
        },
    },
    {
        path: `/${prefix}/suppliers/view/:supplierID`,
        name: `${prefix}.suppliers.view`,
        component: () => import('./View.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.suppliers.index`,
                PageDescription: "Supplier Configurations: Supplier Configuration",
            },
        },
    },
];